module.exports = __webpack_public_path__ + "img/705-2d4670.png";